import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import lang_en from './en/index.json';

i18next
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        debug: false,
        nsSeparator: false,
        react: {
            useSuspense: true
        },
        // the translations
        // (tip move them in a JSON file and import them,
        // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
        resources: {
            en: {translation: lang_en}
        },
        lng: "en", // if you're using a language detector, do not define the lng option
        fallbackLng: "en",

        interpolation: {
            escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        }
    });
